var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.71 14",
    style: {
      enableBackground: "new 0 0 15.71 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-monitor",
    className: "st0",
    d: "M0.68,0C0.31,0,0,0.31,0,0.68v9.9c0,0.38,0.31,0.68,0.68,0.68h14.34 c0.38,0,0.68-0.31,0.68-0.68v-9.9C15.71,0.31,15.4,0,15.02,0H0.68z M0.68,0.68h14.34v9.9V8.54H0.68V0.68z M13.32,9.56H14v0.68h-0.68 L13.32,9.56z M5.8,11.95v0.68H4.78c-0.49-0.07-0.95,0.27-1.02,0.77c-0.01,0.08-0.01,0.17,0,0.26V14h8.2v-0.34 c0.07-0.49-0.27-0.95-0.77-1.02c-0.08-0.01-0.17-0.01-0.26,0H9.9v-0.68L5.8,11.95z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenter);
export default __webpack_public_path__ + "static/media/presenter.fa8d389ac80b6a741e8d0379c8f8840c.svg";
export { ForwardRef as ReactComponent };